import React, { useEffect, useState } from "react";
import { ReactElement } from "react";
import { Typography, Grid, Box, Card } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "redux/store/store";
import { ListSkeleton } from "components/listSkeleton";
import style from "./index.module.scss";
import { getKeycloakToken } from "config/keycloak";
import { grpc } from "@improbable-eng/grpc-web";
import { LiveMeditationService } from "api/models/live-meditation-service/live-meditation_pb_service";
import { LIVE_MEDITATION_SERVICE_HOST } from "api/serviceEndpoints";
import {
  ReportTypeWithIdRequest,
  ResponseForLiveSessionFeedBacks,
} from "api/models/live-meditation-service/live-meditation_pb";
import InfoCard from "./infoCard";
interface Props {
  setcurrentIndex: any;
  sessionTitle?: string;
  sessionId: number;
  coachIdForViewQuestions: number;
}

const ViewFeedback = React.forwardRef<HTMLDivElement, Props>(
  (
    { setcurrentIndex, sessionId, sessionTitle, coachIdForViewQuestions },
    ref
  ): ReactElement => {
    const fb = useSelector(
      (state: RootState) =>
        state.liveMeditation.feedbackList[sessionId.toString()]
    );
    const state = { ...fb };
    const [LiveFeedbackList, setLiveFeedbackList] = useState<any>([]);

    useEffect(() => {
      getDynamicLiveFeedback(sessionId);
      return function () {
        rpc.close();
      };
    }, []);
    let rpc: any;
    const getDynamicLiveFeedback = async (sessionID: number) => {
      const jwtToken = await getKeycloakToken();
      const reqBody: ReportTypeWithIdRequest = new ReportTypeWithIdRequest();
      reqBody.setId(sessionID);
      reqBody.setUserreporttype(0);
      rpc = grpc.invoke(LiveMeditationService.GetDynamicFeedBacksV2, {
        host: LIVE_MEDITATION_SERVICE_HOST,
        request: reqBody,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },
        onMessage: (res: ResponseForLiveSessionFeedBacks) => {
          setLiveFeedbackList(res.toObject().userlivesessionfeedbackList);
          console.log("message recieved", res.toObject());
        },
        onEnd: (res: any) => {
          console.log("stream end");
        },
      });
    };
    const renderFeedbackList = () => {
      return (
        <Box
          height="50vh"
          style={{ overflow: "auto" }}
          className={style.scrollbar}
        >
          {LiveFeedbackList.length > 0 ? (
            <Box>
              {LiveFeedbackList.map((item: any, index: any) => (
                <InfoCard item={item} index={index} />
              ))}
            </Box>
          ) : (
            <Box
              sx={{
                fontWeight: 400,
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" color="text.secondary">
                There is no feedback at this time
              </Typography>
            </Box>
          )}
        </Box>
      );
    };
    return (
      <div ref={ref}>
        {
          <Card sx={{ minWidth: "100%" }}>
            <Grid
              sx={{
                backgroundColor: "primary.main",
                color: "white",
                marginBottom: "2px",
                boxShadow: 2,
              }}
              className="d-flex p-3 px-4 align-items-start"
            >
              <Typography variant="h6">
                Feedbacks ({LiveFeedbackList.length})
              </Typography>
            </Grid>
            {state.loading ? ListSkeleton() : renderFeedbackList()}
          </Card>
        }
      </div>
    );
  }
);
export default ViewFeedback;
